import type { SanityPageBuilderHeadlineDSection, SanityPageBuilderSection } from "@ouster/shared";
import { HeadlineDBlockView } from "~/features/blocks/inventory/headline-d";
import { toCraftLinkArray } from "~/features/sanity/link";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderHeadlineDSection;
  };
};
export function SanityHeadlineDSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <HeadlineDBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} hasSolidBackground={sectionContent.hasSolidBackground} hasSpacer={sectionContent.hasSpacer} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} link={toCraftLinkArray(sectionContent.link)} linkVariant={sectionContent.linkVariant} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}